export default "__VITE_ASSET__$08TLyJA__"